/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Reject_AllInputs */

const da_consent_reject_all = /** @type {(inputs: Consent_Reject_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afvis alle`)
};

/** @type {(inputs: Consent_Reject_AllInputs) => LocalizedString} */
const en_consent_reject_all = da_consent_reject_all;

/**

* @param {Consent_Reject_AllInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const consent_reject_all = /** @type {((inputs?: Consent_Reject_AllInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Reject_AllInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_consent_reject_all(inputs)
	return /** @type {LocalizedString} */ ("Afvis alle")
});